import React, { useState, useEffect } from "react"
import { auth, db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import {  Link } from 'react-router-dom';
import '../Css/UserDetails.css';

export default function UserDetails({ user }) {
    const handleLogout = () => {
        auth.signOut();
    };

    return (
        <>  
            <div className="dashboard-wrapper">
                <h1>Hello {user}</h1>
                <h2>Welcome to your Dashboard</h2>
                <p>More Info. coming soon!</p>
                <button onClick={handleLogout}>Logout</button> <br />
            </div>
        </>
    );
}